import toast from "react-hot-toast";

export default function handleError(error) {
  if (!error) return;

  if (error.response?.status === 401) {
    // Full reload (not router.push) so all client/session state is cleared when
    // the session has expired.
    // eslint-disable-next-line @next/next/no-location-assign-relative-destination
    window.location.href = "/login";
  } else {
    console.error(error);
    toast.error(error.message);
  }
}
